import { ReactNode } from 'react';

import classes from './GridEmptyState.module.scss';

interface GridEmptyStateProps {
  // nothing shows while the grid's data is loading
  loading?: boolean;
  // a search returned nothing, so say so instead of the plain message
  search?: boolean;
  message?: ReactNode;
  action?: ReactNode;
}

const GridEmptyState = ({ loading = false, search = false, message, action }: GridEmptyStateProps): JSX.Element | null => {
  if (loading) {
    return null;
  }

  return (
    <div className={classes.gridEmptyState}>
      {search && <h3 className="title">No Results Found</h3>}
      <p className="message">{message ?? (search ? 'We couldn’t find anything to match your search inquiry.' : 'No Records Found')}</p>
      {action && <div className="action">{action}</div>}
    </div>
  );
};

export default GridEmptyState;
